import { render, staticRenderFns } from "./dates.vue?vue&type=template&id=b16229ca&scoped=true"
import script from "./dates.vue?vue&type=script&lang=ts"
export * from "./dates.vue?vue&type=script&lang=ts"
import style0 from "./dates.vue?vue&type=style&index=0&id=b16229ca&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16229ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b16229ca')) {
      api.createRecord('b16229ca', component.options)
    } else {
      api.reload('b16229ca', component.options)
    }
    module.hot.accept("./dates.vue?vue&type=template&id=b16229ca&scoped=true", function () {
      api.rerender('b16229ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dates/dates.vue"
export default component.exports